export default __webpack_public_path__ + "static/media/Schneider-legrand3mob.e59eeb13.jpg";